import apiClient from './client';
import { setupClientIdInterceptor } from '../../utils/apiInterceptor';
// DISABLED: ClientIdAudit
// import { initializeClientIdAudit } from '../../utils/clientIdAudit';
// import { workflowService } from './workflowService';
// Import any other services that should be audited

/**
 * Initialize client ID handling for the application
 * This should be called during application startup
 */
export const initializeClientIdHandling = () => {
  // Set up the client ID interceptor for the global API client
  setupClientIdInterceptor(apiClient);
  
  console.log('Client ID handling initialized');
  
  // DISABLED: Client ID audit - creates too much console noise
  // Run client ID audit in development environment
  // if (process.env.NODE_ENV === 'development') {
  //   // Collect all services to audit
  //   const services = {
  //     workflowService,
  //     // Add other services here
  //   };
  //   
  //   // Initialize the audit
  //   initializeClientIdAudit(services);
  // }
  
  // Return the apiClient for chaining if needed
  return apiClient;
};

// Export for direct usage
export default initializeClientIdHandling; 